import './tabella.scss';

/**
 * version    1.0
 * class      <type> (Tabella)
 * classdesc  Tabella: horizontally scrollable, managed by a RTE field in Coremedia
 */
export class Tabella {}
